import React, { memo } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

const LifeCycleSection = memo(({ theme, sectionId }) => {
  const LifeCycleLayout = dynamic(() => import(/* webpackChunkName: 'LifeCycleSectionLayout' */ `../../../../../containers/home-page/views/sections/life-cycle/layouts/${theme.layout}`))

  return (
    <LifeCycleLayout sectionId={sectionId} />
  )
}, (prevProps, nextProps) => {
  return (prevProps.theme && prevProps.theme.layout) === (nextProps.theme && nextProps.theme.layout)
})

LifeCycleSection.propTypes = {
  theme: PropTypes.object,
  sectionId: PropTypes.number
}

export default LifeCycleSection
